"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaField = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var InputField_1 = require("../InputField/InputField");
var TextareaField_style_1 = require("./TextareaField.style");
var TextareaField = function (_a) {
    var label = _a.label, name = _a.name, placeholder = _a.placeholder, value = _a.value, validation = _a.validation, required = _a.required, disabled = _a.disabled, maxLength = _a.maxLength, onChange = _a.onChange, onBlur = _a.onBlur;
    var customClasses = (0, TextareaField_style_1.useTextareaFieldStyles)();
    var NUMBER_ROWS = 'true';
    var DEFAULT_MAX_LENGTH = 9999;
    return (react_1.default.createElement(InputField_1.InputField, { multiline: true, rows: NUMBER_ROWS, label: label, name: name, placeholder: placeholder, value: value, type: InputField_1.InputType.Text, validation: validation, required: required, disabled: disabled, onChange: onChange, onBlur: onBlur, classes: customClasses, maxLength: maxLength ? maxLength : DEFAULT_MAX_LENGTH }));
};
exports.TextareaField = TextareaField;
